// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","Inputs":"App_Inputs__cLp-p","Plots":"App_Plots__yMKFO"};